import { Form, Select, SelectProps } from 'antd';
import { useField } from 'formik';
import { FormLabel } from './FormLabel';

interface Props extends SelectProps {
  fieldName: string;
  label?: string;
  loader?: boolean;
}

export const EmployeeSelectInput = ({ fieldName, label, loader, ...rest }: Props): JSX.Element => {
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField<string>(fieldName);

  return (
    <Form.Item
      labelAlign="left"
      validateStatus={touched && error ? 'error' : 'success'}
      label={label ? <FormLabel label={label} /> : undefined}
      help={touched && error ? error : undefined}
      style={{ marginBottom: 0 }}
      labelCol={{ style: { padding: 0 } }}>
      <Select
        {...rest}
        loading={loader}
        defaultValue={value}
        onSelect={(value) => setValue(value as string)}
        onFocus={(): void => setTouched(false)}
        onBlur={(): void => setTouched(true)}
        onClear={(): void => setValue('')}
        allowClear
        style={{ borderRadius: 5 }}
      />
    </Form.Item>
  );
};
